import axios from 'axios'

import { ref } from 'vue'

export default function usePaginatedRegisters() {
  const search_and_paginate_api_path = ref('')
  const get_api_path = ref('')
  const save_api_path = ref('')
  const destroy_api_path = ref('')

  const listRegisters = async (page = 1, per_page = 10, register_filters) => {
    var filters = Object.keys(register_filters)
      .filter(Boolean)
      .map((key) => ({ [key]: register_filters[key] }))
      .reduce((result, current) => Object.assign(result, current), {})

    return new Promise((resolve, reject) => {
      axios
        .get(search_and_paginate_api_path.value, {
          params: Object.assign(
            {
              page,
              per_page,
            },
            filters,
          ),
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }

  const getRegister = async (id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(get_api_path.value + id)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }

  const saveRegister = async (register) => {
    const form_data = new FormData()

    Object.keys(register).forEach((key) => {
      if (register[key] != null) {
        form_data.append(key, register[key])
      }
    })

    return new Promise((resolve, reject) => {
      axios
        .post(save_api_path.value, form_data)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }

  const destroyRegister = async (id) => {
    axios.delete(destroy_api_path.value + id)
  }

  return {
    search_and_paginate_api_path,
    get_api_path,
    destroy_api_path,
    save_api_path,
    listRegisters,
    destroyRegister,
    saveRegister,
    getRegister,
  }
}
